/** Geometry for the bottom-right resize chrome. Visual sits on the node corner. */

export const RESIZE_HANDLE = {
  visual: 8,
  hit: 16,
  /** Distance from the right/bottom edge to the visual square's top-left. */
  inset: 8,
} as const;

export interface ResizeHandleLayout {
  hitX: number;
  hitY: number;
  visualX: number;
  visualY: number;
  hitOffsetX: number;
  hitOffsetY: number;
}

export function resizeHandleLayout(nodeWidth: number, nodeHeight: number): ResizeHandleLayout {
  const visualX = nodeWidth - RESIZE_HANDLE.inset;
  const visualY = nodeHeight - RESIZE_HANDLE.inset;
  const hitX = nodeWidth - RESIZE_HANDLE.hit;
  const hitY = nodeHeight - RESIZE_HANDLE.hit;
  return {
    hitX,
    hitY,
    visualX,
    visualY,
    hitOffsetX: hitX - nodeWidth,
    hitOffsetY: hitY - nodeHeight,
  };
}

/** True when the pointer is in the BR corner reserved for the resizer. */
export function isResizeKeepout(localX: number, localY: number, width: number, height: number): boolean {
  return localX >= width - RESIZE_HANDLE.hit && localY >= height - RESIZE_HANDLE.hit;
}

export function sizeFromHandleDrag(hitX: number, hitY: number, layout: ResizeHandleLayout): { width: number; height: number } {
  return {
    width: hitX - layout.hitOffsetX,
    height: hitY - layout.hitOffsetY,
  };
}

/** New size from pointer movement in the node space frozen at drag start (ignores the group shifting). */
export function sizeFromFrozenPointer(
  origin: { width: number; height: number },
  startLocal: { x: number; y: number },
  currentLocal: { x: number; y: number },
): { width: number; height: number } {
  return {
    width: origin.width + currentLocal.x - startLocal.x,
    height: origin.height + currentLocal.y - startLocal.y,
  };
}

/** Outline misses the AABB corner — a faint handle is the only way to find it. */
const IDLE_RESIZE_HINT_TYPES = new Set([
  'oval', 'diamond', 'hexagon', 'triangle', 'cross', 'cylinder',
  'database', 'queue', 'decision',
  'net_cloud', 'net_host', 'net_firewall', 'net_router', 'net_lb', 'net_switch',
  'pipe_source', 'pipe_process', 'pipe_store', 'pipe_sink', 'pipe_queue',
  'uml_actor',
]);

export function showsIdleResizeHint(type: string): boolean {
  return IDLE_RESIZE_HINT_TYPES.has(type);
}
